import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const JobInterviewForm = () => {
  const [positionDescription, setPositionDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!positionDescription.trim()) {
      setError('Please enter a position description');
      return;
    }
    
    setIsSubmitting(true);
    setError(null);
    
    try {
      const formData = new FormData();
      formData.append('position-description', positionDescription);
      
      const response = await axios.post('/interview/create_job_interview_minimal', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true
      });
      
      // If successful, redirect to the conversation page
      if (response.data.redirect) {
        window.location.href = response.data.redirect;
      } else {
        navigate('/job-interview-conversation');
      }
    } catch (err) {
      console.error('Error submitting position description:', err);
      setError(err.response?.data?.error || 'Failed to create job interview. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="card shadow-sm bg-white rounded">
      <div className="card-header bg-primary text-white">
        <h3 className="mb-0">Job Interview Simulation</h3>
      </div>
      <div className="card-body">
        <h4 className="card-title">Create a Job Interview with Jacob</h4>
        <p className="card-text">
          Paste a job position description below to start a simulated interview with Jacob Smith, 
          an AI-powered HR interviewer.
        </p>
        
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="position-description" className="form-label">Position Description</label>
            <textarea 
              className="form-control" 
              id="position-description" 
              rows="8" 
              value={positionDescription}
              onChange={(e) => setPositionDescription(e.target.value)}
              placeholder="Paste the job position description here..."
              required
            />
          </div>
          <div className="d-grid">
            <button 
              type="submit" 
              className="btn btn-success"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Processing...
                </>
              ) : (
                'Start Interview Simulation'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default JobInterviewForm; 